import React, { useEffect, useState } from 'react';
import "./css/common.css"
import { useTranslation } from 'react-i18next';


export default function MatchWidget(props) {
    const [hideTech, setTech] = useState(true);
    const { t, i18n } = useTranslation();

    if(props.a2lAmin){
        props.model.technical_data['Amin'] = props.a2lAmin;
    }

    var technical_array = Object.keys(props.model.technical_data).map((key) => [key, props.model.technical_data[key]]);
    technical_array.sort((a, b) => {
        if (a[0] === "Amin") return -1; 
        if (b[0] === "Amin") return 1;
        return 0; 
    });
    
    var technical_all = (technical_array.map((data) => {
        var data_value = data[1];
        if (data[0] === "Capacity") {
            data_value = Number(data[1]).toLocaleString();
        }

        return (
            <>

                <div key={data[0]}>
                    <span className="badge badge-grey text-center mt-2 mb-2 col-sm-12">
                        <span className="subgery">{data[0]}</span>  <span className="textst_ns">{data_value}</span>
                    </span>
                </div>
            </>

        )
    }
    ))

    // {props.a2lAmin && (
    //     <span className="badge badge-grey text-center mt-2 mb-2 col-sm-12">
    //         <span className="subgery">Amin</span>
    //         <span className="textst_ns">{props.a2lAmin}</span>
    //     </span>
    // )}

    var technical_data_first = technical_all.slice(0, 3);
    var technical_data_rest = technical_all.slice(2 + 1);
    var condn_units_count = (Number(props.condn_units_count))
    return (<>
        <div className="text-center"> <b className="color-blue ">{props.head}</b></div>
        <div className="text-center ">
            <div className=" bshadow">
                <img src={props.img} className="img-thumbnail bordernone pt-3" />
            </div>
            <div className="btn-blue  stbl_he"> <b>{props.model.model}{props.selected_option_code}</b></div>
        </div>
        <div className=" bshadow p-15">
            <div className="form-group">
                <label htmlFor="exampleFormControlSelect1" className="mb-0"><b className="font-18">{t('matchpages.prfd_opts')}</b></label>
                <select className="form-control font-18 form-control-sm" value={props.selected_option_code} onChange={(e) => { props.updateOption("selected_option", e.target.value) }}>
                    {

                        props.model.option_packages.map((option) => {
                            var errCodeFlag = ((option.err_code === "" || option.err_code === "02") ? true : false);
                            var hideOption = ((option.err_code === "01") ? true : false);
                            let isB0000 = option.code === "B0000";

                            if(hideOption) return null;
                            
                            return (
                                <option
                                    value={option.code}
                                    key={option.code}
                                    style={{
                                        display: (isB0000 && localStorage.getItem("rds") === "Factory Installed") ||
                                            (localStorage.getItem("rds") === "Field Installed" && option.code !== "B0000" && option.code.charAt(0) !== 'A') ? 'none' : 'block'
                                    }}
                                >
                                    {option.code} - {option.label} - {
                                        (errCodeFlag ?
                                            (option.err_code === "" ? "$" + Number(option.price).toLocaleString() : option.price) :
                                            (option.err_code === "" ? "$" + Number(option.price).toLocaleString() : "")
                                        )
                                    }
                                </option>


                            )
                        }


                        )}
                </select>
            </div>
            <button type="button" className={(!isNaN(props.model.awef)) ? "col-sm-12 btn btn-green" : "col-sm-12 btn btn-red"}><b className="subsec">{t('matchpages.awef')}</b><span className="font-18">{props.model.awef}</span></button>
            <div className="mt-2">
                <div><label className="empty_label btn-green m-0 mr-2"></label><span className="font-12">{t('matchpages.meets_min_awef')}</span></div>
                <div><label className="empty_label btn-red m-0 mr-2"></label><span className="font-12">{t('matchpages.dnt_meet_min_awef')}</span></div>
            </div>

            {technical_data_first}
            <div className={hideTech ? "color-blue mb-2 " : "color-blue mb-2 hideme"} style={{ cursor: "pointer" }} onClick={() => setTech(!hideTech)}><b>{t('matchpages.view_more_tech')}</b></div>
            <div className={hideTech ? "hideme" : ""}>{technical_data_rest}</div>
            <div className={hideTech ? "color-blue mb-2 hideme" : "color-blue mb-2"} style={{ cursor: "pointer" }} onClick={() => setTech(!hideTech)}><b>{t('matchpages.hide_tech_data')}</b></div>

            {/*         
        <div><span className="badge badge-smblue text-center mb-2 col-sm-12">
            <span className="textst" style={{cursor:"pointer"}} onClick={()=>props.navigate((props.headback))} ><b>{props.head==="Condensing Unit"?"Edit Condensing Unit Options":"Edit Evaporator Options"}</b></span>
        </span></div> */}
            <div><span className="badge badge-black col-sm-12">
                <span style={{ cursor: "pointer" }}  ><b>{t('common.Total')}: {(String(props.price) === "0" || String(Number(props.price)) === "NaN") ? "-" : "$" + (props.price).toLocaleString() + "X" + String(Number(props.model.count) * condn_units_count)}</b></span>
            </span></div>

        </div>
    </>
    )
}